import React from 'react'
import CountUp from './CountUp'
import Credit from './Credit'
import { usePhotos } from '../i18n/hooks'
import { useI18n } from '../i18n/LanguageContext'

function Hero() {
  const { t } = useI18n()
  const { photos } = usePhotos()
  const photo = photos['village-minaret']

  return (
    <section className="hero" id="top">
      <div className="hero-media" aria-hidden="true">
        <img className="hero-img" src={photo.src} alt="" fetchPriority="high" />
      </div>
      <div className="container hero-content">
        <p className="eyebrow hero-in" style={{ '--i': 0 }}>{t.hero.eyebrow}</p>
        <h1 className="hero-in" style={{ '--i': 1 }}>
          Nanovitsa
          <span className="hero-bg-name" lang="bg">Нановица</span>
        </h1>
        <p className="hero-lead hero-in" style={{ '--i': 2 }}>{t.hero.lead}</p>
        <div className="hero-actions hero-in" style={{ '--i': 3 }}>
          <a className="button" href="#explore">{t.hero.exploreBtn}</a>
          <a className="button button-ghost" href="#map">{t.hero.mapBtn}</a>
        </div>
        <dl className="hero-stats hero-in" style={{ '--i': 4 }}>
          <div>
            <dt>{t.hero.stats.elevation}</dt>
            <dd><CountUp to={308} /> <small>m</small></dd>
          </div>
          <div>
            <dt>{t.hero.stats.population}</dt>
            <dd><CountUp to={456} /></dd>
          </div>
          <div>
            <dt>{t.hero.stats.area}</dt>
            <dd><CountUp to={5.2} decimals={1} /> <small>km²</small></dd>
          </div>
          <div>
            <dt>{t.hero.stats.postal}</dt>
            <dd>6830</dd>
          </div>
        </dl>
      </div>
      <Credit photo={photo} className="hero-credit" />
    </section>
  )
}

export default Hero
